import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { createLoginRoute } from '../constants/route_generation';
import { Auth } from '../services/auth';

export const AuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean | UrlTree => {
  const authService = inject(Auth);
  const router = inject(Router);
  if (authService.isAuthenticated()) {
    return true;
  } else {
    return router.createUrlTree([createLoginRoute()], {
      queryParams: { returnUrl: state.url },
    });
  }
};
